import MarkdownIt from 'markdown-it';
import Quill from 'quill';
import Delta from 'quill-delta';
import { useCallback, useMemo } from 'react';
import TurndownService from 'turndown';

// Only use the .clipboard.convert() method, do not instantiate
const quill = new Quill(document.createElement('div'));

export function useMarkdownConverter() {
	const markdownIt = useMemo(() => new MarkdownIt(), []);
	const turndownService = useMemo(() => new TurndownService(), []);

	const markdownToQuillDelta = useCallback(
		(markdown: string): Delta => {
			const html = markdownIt.render(markdown);
			// Quill's clipboard.convert() may not properly insert newlines between
			// adjacent block elements. Ensure headings are preceded by a <br> so the
			// clipboard always recognizes the block boundary.
			const processed = html.replace(
				/(<\/(?:p|ul|ol|blockquote|pre|h[1-6])>)\s*(<h[1-6])/gi,
				'$1<br>$2',
			);
			return quill.clipboard.convert({ html: processed });
		},
		[markdownIt],
	);

	const htmlToMarkdown = useCallback(
		(html: string): string => {
			return turndownService.turndown(html);
		},
		[turndownService],
	);

	return { markdownToQuillDelta, htmlToMarkdown };
}
